import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const PreLoaderWrapper = styled.div`
  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
  width: 100%;
  height: 100%;
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  transition: all 0.25s linear;
  ${props =>
    props.hidden
      ? `    
    transition-delay: .50s;
    opacity: 0;
    pointer-events: none;
  `
      : ''};
  ${props =>
    props.manual &&
    `position: absolute;
    z-index: 9;
    width: 100%;
    height: 100%;`};
  .indicator {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(4);
  }
  .indicator svg polyline {
    fill: none;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .indicator svg polyline#back {
    stroke: rgba(59, 211, 171, 0.3);
  }
  .indicator svg polyline#front {
    stroke: #3bd3ab;
    stroke-dasharray: 12, 36;
    stroke-dashoffset: 48;
    animation: dash 1s linear infinite;
  }
  @-moz-keyframes dash {
    62.5% {
      opacity: 0;
    }
    to {
      stroke-dashoffset: 0;
    }
  }
  @-webkit-keyframes dash {
    62.5% {
      opacity: 0;
    }
    to {
      stroke-dashoffset: 0;
    }
  }
  @-o-keyframes dash {
    62.5% {
      opacity: 0;
    }
    to {
      stroke-dashoffset: 0;
    }
  }
  @keyframes dash {
    62.5% {
      opacity: 0;
    }
    to {
      stroke-dashoffset: 0;
    }
  }
`;

const PreLoader = props => {
  const { manualTrigger, showPreLoader, isLocal, show } = props;
  let isHidden = isLocal ? !show : !showPreLoader;
  if (typeof manualTrigger === 'boolean') {
    isHidden = !manualTrigger;
  }

  return (
    <PreLoaderWrapper hidden={isHidden} manual={typeof manualTrigger === 'boolean'}>
      <div className="indicator">
        <svg width="16px" height="12px">
          <polyline id="back" points="1 6 4 6 6 11 10 1 12 6 15 6" />
          <polyline id="front" points="1 6 4 6 6 11 10 1 12 6 15 6" />
        </svg>
      </div>
    </PreLoaderWrapper>
  );
};

PreLoader.propTypes = {
  showPreLoader: PropTypes.bool
};

PreLoader.defaultProps = {
  showPreLoader: false
};

const mapStateToProps = state => ({
  showPreLoader: state.ui.showPreLoader
});

export default connect(mapStateToProps)(PreLoader);
